export const getCategoriesURL = 'catalog/categories?state={state}'
export const homePageItemsURL = 'content/v1/delivery/content/find/home-page?v=5'
export const fetchSubCategories = 'inventory/digital/v3/store/{storeId}/facet'
export const fetchCateringProducts = 'inventory/digital/v3/store/{storeId}/preorder/facet'
export const fetchGlobalCategoriesUrl = 'catalog/find/products/facet'
export const fetchGlobalCateringProductsUrl = 'catalog/find/products/facet/platter'
export const getFiltersURL = 'catalog/products/filters'
export const getCateringFiltersURL = 'catalog/products/filters/platter'
export const productDetailsByIdURL = '/catalog/products/{id}/details'
export const productDetailsURL = 'inventory/store/{storeId}/products/{id}/details' // new url
export const productSearchUrl = '/catalog/search/products'
export const storeProductSearchUrl = 'inventory/digital/v3/store/{storeId}/products/search'
export const getStoreAddressUrl = 'customers/v2/address'
export const homePageCategoryURL = 'content/v1/delivery/content/find/category-list?v=5'
